export class State {
  private _loaded = false;
  private _operating = false;
  private _state = 'success';
  private _message: string;
  private _message_en: string;
  public get loaded() {
    return this._loaded;
  }
  public set loaded(value) {
    this._loaded = value;
  }

  public get operating() {
    return this._operating;
  }
  public set operating(value) {
    this._operating = value;
  }

  public get state() {
    return this._state;
  }
  public set state(value) {
    this._state = value;
  }

  public get message(): string {
    return this._message;
  }
  public set message(value: string) {
    this._message = value;
  }

  public get message_en(): string {
    return this._message_en;
  }
  public set message_en(value: string) {
    this._message_en = value;
  }
}
